// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39qGl","footer":"styles_footer__H_lyT","passCodeTooltip":"styles_passCodeTooltip__2qWW0"};